import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeFounder: [
    {
      id: 1,
      founderName: "James Whitaker",
      email: "james@gmail.com",
      option:[ "OPTION_1"],
      startupName: "Zentrova",
      industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
      startupStage: ["IDEA",],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 2, 2024",
      lastActive: "May 2, 2024"
    },
    {
      id: 2,
      founderName: "Olivia Hastings",
      email: "olivia@gmail.com",
      option:[ "OPTION_1", "OPTION_2"],
      startupName: "Blinknest",
      industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
      startupStage: ["MVP",],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 3, 2024",
      lastActive: "May 3, 2024"
    },
    {
      id: 3,
      founderName: "Brandon Cole",
      email: "brandon@gmail.com",
      option:[ "OPTION_3"],
      startupName: "Nuvoro",
      industry: ["CYBERSECURITY"],
      startupStage: ["MVP",],
      founders: "2",
      investmentTerm: "CONVERTIBLE",
      dateRegistered: "April 29, 2024",
      lastActive: "April 29, 2024"
    },
    {
      id: 4,
      founderName: "Sophia Klein",
      email: "sophia@gmail.com",
      option:[ "OPTION_2"],
      startupName: "Loopy",
      industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
      startupStage: ["PRE_SEED",],
      founders: "2",
      investmentTerm: "EQUITY",
      dateRegistered: "April 17, 2024",
      lastActive: "April 17, 2024"
    },
    {
      id: 5,
      founderName: "Ethan Morales",
      email: "ethan@gmail.com",
      option:[ "OPTION_4", "OPTION_1"],
      startupName: "Quantaire",
      industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
      startupStage: ["IDEA",],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 16, 2024",
      lastActive: "May 16, 2024"
    },
    {
      id: 6,
      founderName: "Madison Lee",
      email: "madison@gmail.com",
      option:[ "OPTION_5"],
      startupName: "Froviq",
      industry: ["E_COMMERCE_RETAIL"],
      startupStage: ["MVP", "SERIES_A"],
      founders: "1",
      investmentTerm: "REVENUE_BASE",
      dateRegistered: "June 1, 2024",
      lastActive: "June 1, 2024"
    },
    {
      id: 7,
      founderName: "Dylan Prescott",
      email: "dylan@gmail.com",
      option:[ "OPTION_1", "OPTION_2"],
      startupName: "Twoylft",
      industry: ["CYBERSECURITY"],
      startupStage: ["SERIES_A", "MVP", "SERIES_B"],
      founders: "4",
      investmentTerm: "GRANTS",
      dateRegistered: "April 17, 2024",
      lastActive: "April 17, 2024"
    },
    {
      id: 8,
      founderName: "Isabella Novak",
      email: "isabella@gmail.com",
      option:[ "OPTION_3", "OPTION_1"],
      startupName: "Veltrix",
      industry: ["GAMING_ENTERTAINMENT"],
      startupStage: ["SERIES_B",],
      founders: "2",
      investmentTerm: "LOAN",
      dateRegistered: "April 21, 2024",
      lastActive: "April 21, 2024"
    },
    {
      id: 9,
      founderName: "Marcus Bell",
      email: "marcus@gmail.com",
      option:[ "OPTION_6", "OPTION_7"],
      startupName: "Kyndra",
      industry: ["HEALTH_BIOTECH"],
      startupStage: ["PRE_SEED",],
      founders: "3",
      investmentTerm: "CROWDFUNDING",
      dateRegistered: "April 29, 2024",
      lastActive: "April 29, 2024"
    },
    {
      id: 10,
      founderName: "Chloe Ramsey",
      email: "chloe@gmail.com",
      option:[ "OPTION_1"],
      startupName: "Oblio Labs",
      industry: ["AI_MACHINE_LEARNING"],
      startupStage: ["IDEA",],
      founders: "3",
      investmentTerm: "OTHER",
      dateRegistered: "July 13, 2024",
      lastActive: "July 13, 2024"
    }
  ],
  notCompletedFounder: [
    {
      id: 1,
      founderName: "James Whitaker",
      email: "james@gmail.com",
      option:[ "OPTION_1"],
      startupName: "Zentrova",
      industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
      startupStage: ["IDEA",],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 2, 2024",
      lastActive: "May 2, 2024"
    },
    {
      id: 2,
      founderName: "Olivia Hastings",
      email: "olivia@gmail.com",
      option:[ "OPTION_1", "OPTION_2"],
      startupName: "Blinknest",
      industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
      startupStage: ["MVP",],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 3, 2024",
      lastActive: "May 3, 2024"
    },
    {
      id: 3,
      founderName: "Brandon Cole",
      email: "brandon@gmail.com",
      option:[ "OPTION_3"],
      startupName: "Nuvoro",
      industry: ["CYBERSECURITY"],
      startupStage: ["MVP",],
      founders: "2",
      investmentTerm: "CONVERTIBLE",
      dateRegistered: "April 29, 2024",
      lastActive: "April 29, 2024"
    },
    {
      id: 4,
      founderName: "Sophia Klein",
      email: "sophia@gmail.com",
      option:[ "OPTION_2"],
      startupName: "Loopy",
      industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
      startupStage: ["PRE_SEED",],
      founders: "2",
      investmentTerm: "EQUITY",
      dateRegistered: "April 17, 2024",
      lastActive: "April 17, 2024"
    },
    {
      id: 5,
      founderName: "Ethan Morales",
      email: "ethan@gmail.com",
      option:[ "OPTION_4", "OPTION_1"],
      startupName: "Quantaire",
      industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
      startupStage: ["IDEA",],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 16, 2024",
      lastActive: "May 16, 2024"
    },
    {
      id: 6,
      founderName: "Madison Lee",
      email: "madison@gmail.com",
      option:[ "OPTION_5"],
      startupName: "Froviq",
      industry: ["E_COMMERCE_RETAIL"],
      startupStage: ["MVP", "SERIES_A"],
      founders: "1",
      investmentTerm: "REVENUE_BASE",
      dateRegistered: "June 1, 2024",
      lastActive: "June 1, 2024"
    },
    {
      id: 7,
      founderName: "Dylan Prescott",
      email: "dylan@gmail.com",
      option:[ "OPTION_1", "OPTION_2"],
      startupName: "Twoylft",
      industry: ["CYBERSECURITY"],
      startupStage: ["SERIES_A", "MVP", "SERIES_B"],
      founders: "4",
      investmentTerm: "GRANTS",
      dateRegistered: "April 17, 2024",
      lastActive: "April 17, 2024"
    },
    {
      id: 8,
      founderName: "Isabella Novak",
      email: "isabella@gmail.com",
      option:[ "OPTION_3", "OPTION_1"],
      startupName: "Veltrix",
      industry: ["GAMING_ENTERTAINMENT"],
      startupStage: ["SERIES_B",],
      founders: "2",
      investmentTerm: "LOAN",
      dateRegistered: "April 21, 2024",
      lastActive: "April 21, 2024"
    },
    {
      id: 9,
      founderName: "Marcus Bell",
      email: "marcus@gmail.com",
      option:[ "OPTION_6", "OPTION_7"],
      startupName: "Kyndra",
      industry: ["HEALTH_BIOTECH"],
      startupStage: ["PRE_SEED",],
      founders: "3",
      investmentTerm: "CROWDFUNDING",
      dateRegistered: "April 29, 2024",
      lastActive: "April 29, 2024"
    },
    {
      id: 10,
      founderName: "Chloe Ramsey",
      email: "chloe@gmail.com",
      option:[ "OPTION_1"],
      startupName: "Oblio Labs",
      industry: ["AI_MACHINE_LEARNING"],
      startupStage: ["IDEA",],
      founders: "3",
      investmentTerm: "OTHER",
      dateRegistered: "July 13, 2024",
      lastActive: "July 13, 2024"
    }
  ],
  suspendedFounder: [
    {
      id: 1,
      founderName: "James Whitaker",
      email: "james@gmail.com",
      option:[ "OPTION_1"],
      startupName: "Zentrova",
      industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
      startupStage: ["IDEA","MVP","PRE_SEED"],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 2, 2024",
      suspendedDate: "September 2, 2024"
    },
    {
      id: 2,
      founderName: "Olivia Hastings",
      email: "olivia@gmail.com",
      option:[ "OPTION_1", "OPTION_2"],
      startupName: "Blinknest",
      industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
      startupStage: ["MVP",],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 3, 2024",
      suspendedDate: "May 3, 2024"
    },
    {
      id: 3,
      founderName: "Brandon Cole",
      email: "brandon@gmail.com",
      option:[ "OPTION_3"],
      startupName: "Nuvoro",
      industry: ["CYBERSECURITY"],
      startupStage: ["MVP","PRE_SEED"],
      founders: "2",
      investmentTerm: "CONVERTIBLE",
      dateRegistered: "April 29, 2024",
      suspendedDate: "April 29, 2024"
    },
    {
      id: 4,
      founderName: "Sophia Klein",
      email: "sophia@gmail.com",
      option:[ "OPTION_2"],
      startupName: "Loopy",
      industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
      startupStage: ["PRE_SEED",],
      founders: "2",
      investmentTerm: "EQUITY",
      dateRegistered: "April 17, 2024",
      suspendedDate: "April 17, 2024"
    },
    {
      id: 5,
      founderName: "Ethan Morales",
      email: "ethan@gmail.com",
      option:[ "OPTION_4", "OPTION_1"],
      startupName: "Quantaire",
      industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
      startupStage: ["IDEA",],
      founders: "3",
      investmentTerm: "SAFE",
      dateRegistered: "May 16, 2024",
      suspendedDate: "May 16, 2024"
    },
    {
      id: 6,
      founderName: "Madison Lee",
      email: "madison@gmail.com",
      option:[ "OPTION_5"],
      startupName: "Froviq",
      industry: ["E_COMMERCE_RETAIL"],
      startupStage: ["MVP",],
      founders: "1",
      investmentTerm: "REVENUE_BASE",
      dateRegistered: "June 1, 2024",
      suspendedDate: "June 1, 2024"
    },
    {
      id: 7,
      founderName: "Dylan Prescott",
      email: "dylan@gmail.com",
      option:[ "OPTION_1", "OPTION_2"],
      startupName: "Twoylft",
      industry: ["CYBERSECURITY"],
      startupStage: ["SERIES_A","MVP"],
      founders: "4",
      investmentTerm: "GRANTS",
      dateRegistered: "April 17, 2024",
      suspendedDate: "April 17, 2024"
    },
    {
      id: 8,
      founderName: "Isabella Novak",
      email: "isabella@gmail.com",
      option:[ "OPTION_3", "OPTION_1"],
      startupName: "Veltrix",
      industry: ["GAMING_ENTERTAINMENT"],
      startupStage: ["SERIES_B",],
      founders: "2",
      investmentTerm: "LOAN",
      dateRegistered: "April 21, 2024",
      suspendedDate: "April 21, 2024"
    },
    {
      id: 9,
      founderName: "Marcus Bell",
      email: "marcus@gmail.com",
      option:[ "OPTION_6", "OPTION_7"],
      startupName: "Kyndra",
      industry: ["HEALTH_BIOTECH"],
      startupStage: ["PRE_SEED","SERIES_A","SERIES_B","MVP"],
      founders: "3",
      investmentTerm: "CROWDFUNDING",
      dateRegistered: "April 29, 2024",
      suspendedDate: "April 29, 2024"
    },
    {
      id: 10,
      founderName: "Chloe Ramsey",
      email: "chloe@gmail.com",
      option:[ "OPTION_1"],
      startupName: "Oblio Labs",
      industry: ["AI_MACHINE_LEARNING"],
      startupStage: ["IDEA",],
      founders: "3",
      investmentTerm: "OTHER",
      dateRegistered: "July 13, 2024",
      suspendedDate: "July 13, 2024"
    }
  ],
  singleFounder: {
    id: 1,
    name: 'Tyler Grayson',
    option:[ 'OPTION_1',  'OPTION_2'],
    role: 'CEO',
    linkedinProfile: 'https://www.linkedin.com/tyler-grayson',
    bio: 'Short bio',
    coFounders: [
      {
        id: 1,
        name: 'Emily Nakamura',
        option:[ 'OPTION_1'],
        role: 'CTO',
        linkedinProfile: 'https://www.linkedin.com/tyler-grayson',
        bio: 'Bio text',
      },
      {
        id: 2,
        name: 'Ben Chang',
        option:[ 'OPTION_1'],
        role: 'COO',
        linkedinProfile: 'https://www.linkedin.com/tyler-grayson',
        bio: 'Bio text',
      },
    ],
    company: {
      name: 'Uniqum',
      tagline: 'Revolutionizing data compression - smaller, faster, and more efficient than ever.',
      industries: '🤖 AI_MACHINE_LEARNING 🔒 CYBERSECURITY',
      startupStage: ['💡 IDEA MVP 🌱 PRE_SEED 🌿 SEED',],
      linkedinPage: 'https://www.linkedin.com/uniqum',
      website: 'https://www.uniqum.ai',
      aboutStartup: 'Uniqum is redefining data compression with its groundbreaking algorithm, making files smaller, transfers faster, and storage more efficient.',
      amount: '52',
      investmentTerm: 'SAFE'
    },
    activity: {
      totalHours: '14.2',
      average: '21.4',
      activityList: [
        {
          name: 'Greg Anderson',
          time: '14.28'
        },
        {
          name: 'Joseph Brad',
          time: '14.23'
        },
        {
          name: 'Tyler Cohen',
          time: '14.54'
        },
        {
          name: 'James Madlin',
          time: '14.50'
        },
      ]
    },
    report: {
      reportList: [
        {
          reportNumber: 'Report #230',
          time: '14.58'
        },
        {
          reportNumber: 'Report #117',
          time: '14.58'
        },
      ]
    },
    adminHistory: [
      {
        reportNumber: 'Changed: Personal Email Address',
        time: '14.58'
      },
      {
        reportNumber: 'Changed: University Email Address',
        time: '14.52'
      },
      {
        reportNumber: 'Restored: Reason',
        time: '14.10'
      },
      {
        reportNumber: 'Suspended: Reason',
        time: '13.50'
      },
    ]
  },
};

const founderSlice = createSlice({
  name: 'founders',
  initialState,
  reducers: {
    setActiveFounders: (state, action) => {
      state.activeFounder = action.payload;
    },
    setNotCompletedFounder: (state, action) => {
      state.notCompletedFounder = action.payload;
    },
    setSuspendFounder: (state, action) => {
      state.suspendedFounder = action.payload;
    },
    setSingleFounder: (state, action) => {
      state.singleFounder = action.payload;
    },
  },
});

export const {
  setActiveFounders,
  setNotCompletedFounder,
  setSuspendFounder,
  setSingleFounder
} = founderSlice.actions;

export default founderSlice.reducer;
